import type * as Types from '@xingternal/pages-graphql-types';

import type { XingIdContactsFragment } from './XingIdContactsFragment.gql-types.js';
import * as Operations from './ContactsQuery.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ContactsQueryVariables = Types.Exact<{
  id: Types.Scalars['SlugOrID']['input'];
  includeDisabledContact?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type ContactsQuery = (
  { __typename?: 'Query' }
  & { viewer?: Types.Maybe<(
    { __typename?: 'Viewer' }
    & Pick<Types.Viewer, 'id'>
    & { xingId?: Types.Maybe<(
      { __typename?: 'XingId' }
      & Pick<Types.XingId, 'id'>
    )> }
  )>, entityPageContactUsers?: Types.Maybe<(
    { __typename?: 'EntityPageContactUsers' }
    & Pick<Types.EntityPageContactUsers, 'total'>
    & { collection: Array<(
      { __typename?: 'EntityPageContactUser' }
      & Pick<Types.EntityPageContactUser, 'id' | 'enabled' | 'label'>
      & { xingId?: Types.Maybe<(
        { __typename?: 'XingId' }
        & XingIdContactsFragment
      )> }
    )> }
  )> }
);



/**
 * __useContactsQuery__
 *
 * To run a query within a React component, call `useContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeDisabledContact: // value for 'includeDisabledContact'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useContactsQuery(baseOptions: Apollo.QueryHookOptions<ContactsQuery, ContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsQuery, ContactsQueryVariables>(Operations.Contacts, options);
      }
export function useContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsQuery, ContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsQuery, ContactsQueryVariables>(Operations.Contacts, options);
        }
export type ContactsQueryHookResult = ReturnType<typeof useContactsQuery>;
export type ContactsLazyQueryHookResult = ReturnType<typeof useContactsLazyQuery>;
export type ContactsQueryResult = Apollo.QueryResult<ContactsQuery, ContactsQueryVariables>;